import {Button} from '@components/common/button/button'
import {NumberInput, TextInput} from '@components/common/text-input/text-input'
import {default as React, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Action, findIdInWorkflow, Workflow, WorkflowConfig} from 'yougile-model'

const ActionInput = (props: {
  workflow: Workflow
  config: WorkflowConfig
  input: Action['inputs'][number]
  inputs: any
  setInputs: (v: any) => void
}) => {
  const {config, input, workflow, inputs, setInputs} = props
  const field = config.fields.find(f => f.name === input.field)
  if (!field) {
    return <React.Fragment key={input.field} />
  }
  const fieldId = findIdInWorkflow(workflow.ids, 'fields', field.name)
  return (
    <div className="flex mt-8 items-center w-200">
      <div className="mr-4">{field.name}:</div>
      {field.type === 'number' && (
        <NumberInput
          value={inputs[fieldId] ?? 0}
          onChange={value => setInputs({...inputs, [fieldId]: value})}
        />
      )}
      {field.type === 'text' && (
        <TextInput
          value={inputs[fieldId] ?? ''}
          onChange={value => setInputs({...inputs, [fieldId]: value})}
        />
      )}
    </div>
  )
}

const TwActionForm = tw.div`
  m-8
  w-240
  flex
  justify-center
  flex-col
  items-center
  text-main-old
`

export const ActionForm = (props: {
  config: WorkflowConfig
  workflow: Workflow
  action: Action
  showTitle?: boolean
  onSubmit: (text: string | undefined, inputs: {[id: string]: unknown}) => void
}) => {
  const {action, onSubmit: create, config, workflow, showTitle} = props
  const [title, setTitle] = useState('')
  const [inputs, setInputs] = useState<any>({})
  const submit = () => create(title, inputs)

  return (
    <TwActionForm>
      <div>{action.name}</div>
      {showTitle && (
        <TextInput
          autoFocus
          placeholder={Lang.msg.taskPlaceholder}
          className="mt-16 w-200"
          value={title}
          onChange={setTitle}
          onEnter={submit}
        />
      )}
      {action.inputs?.map(input => (
        <ActionInput
          key={input.field}
          {...{
            config: config,
            workflow: workflow,
            input,
            inputs,
            setInputs
          }}
        />
      ))}
      <Button className="mt-16 text-center" onClick={submit}>
        {Lang.msg.done}
      </Button>
    </TwActionForm>
  )
}
